<div class="dt-pagination">
  <span class="dt-pagination-summary">
    Showing {{ start }} to {{ end }} of {{ total }} records
    @if (showPageSizeSelector) {
      <label class="dt-pagination-size">
        <span class="dt-pagination-size-label">Rows per page</span>
        <!-- [selected] per option, NOT [value] on the <select>. The select's value is applied before
             @for has created the options, so the browser falls back to showing the first option — the
             control displayed "10" while the table was really paging at 20 (reported 2026-08-10). -->
        <select class="dt-page-size-select"
          aria-label="Rows per page"
          (change)="onPageSizeChange($any($event.target).value)">
          @for (option of options; track option) {
            <option [value]="option" [selected]="option === pageSize">{{ option }}</option>
          }
        </select>
      </label>
    }
  </span>

  <nav class="dt-pagination-nav" aria-label="Table pagination">
    <button type="button" class="dt-page-btn dt-page-prev"
      [disabled]="page <= 1" (click)="prev()" aria-label="Previous page">
      <mat-icon>chevron_left</mat-icon>
      <span>Previous</span>
    </button>

    @for (item of pages; track $index) {
      @if (isNumber(item)) {
        <button type="button" class="dt-page-btn dt-page-num"
          [class.dt-page-active]="item === page"
          [attr.aria-current]="item === page ? 'page' : null"
          (click)="goTo(item)">{{ item }}</button>
      } @else {
        <span class="dt-page-ellipsis">{{ ellipsis }}</span>
      }
    }

    <button type="button" class="dt-page-btn dt-page-next"
      [disabled]="page >= totalPages" (click)="next()" aria-label="Next page">
      <span>Next</span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  </nav>
</div>
